import React, { useCallback } from 'react'

import { useWindowSize } from 'shared/hooks'

// import { AboutUsProductionDesktop } from './ProductionDesktop'
// import { AboutUsProductionDesktopTransform } from './ProductionDesktopTransform'
import { ProductionDesktopV3 } from './ProductionDesktopV3'
import { AboutUsProductionTablet } from './ProductionTablet'

export const AboutUsProduction: React.FC = () => {
  const { isSmallDesktop, isTablet, isMobile } = useWindowSize()

  const render = useCallback(() => {
    if (isSmallDesktop || isTablet || isMobile) {
      return <AboutUsProductionTablet />
    }
    return <ProductionDesktopV3 />
  }, [isMobile, isSmallDesktop, isTablet])
  return render()
}
